import { Component, Input, inject, OnInit } from '@angular/core';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';

@Component({
    selector: 'app-postback-thank-you',
    templateUrl: './postback-thank-you.component.html',
    styleUrls: ['./postback-thank-you.component.scss'],
    standalone: false
})
export class PostbackThankYouComponent implements OnInit {
  private rbs = inject(RightBridgeApiService);

  @Input() context;

  thankYouProfile;

  ngOnInit() {
    this.getGroupProfile();
  }

  getGroupProfile() {
    this.rbs.postGroupProfile('ThankYouPage', 'rb').subscribe(resp => {
      this.thankYouProfile = JSON.parse(resp.UnitInfo.ThankYouPage);
    });
  }
}
